var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actual_section"},[_c('div',{staticClass:"perfil-equipo-1 avenirnextltpro-bold-big-stone-10px"},[_vm._v("Perfil equipo")])])}]

export { render, staticRenderFns }